import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import { Flex } from '@dutchie/common/components/rebass-compat';

import { useUser } from 'src/hooks/use-user';
import { useDispensary } from 'src/hooks/use-dispensary';
import { getAdminAssetUrl } from 'src/utils/admin-asset-url';

export function MobileSidebarHeader(): JSX.Element {
  const User = useUser();
  const dispensary = useDispensary();

  return useObserver(() => (
    <Container>
      <Flex alignItems='flex-start' justifyContent='flex-start'>
        <Image src={dispensary.logoImage ?? getAdminAssetUrl('/icons/dutchie-logo-sand.svg')} />
        <Flex flexDirection='column' justifyContent='flex-start' ml='19px'>
          <TitleText data-testid='admin-title'>{dispensary.name}</TitleText>
          <EmailText data-testid='admin-email'>{User.email}</EmailText>
        </Flex>
      </Flex>
      <Divider />
    </Container>
  ));
}

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #1a5c42;
  margin-top: 26px;
`;

const Container = styled.div`
  width: 100%;
  padding: 32px 30px 0px 30px;
  margin-bottom: 28px;
  box-sizing: border-box;
`;

const Image = styled.img`
  max-height: 70px;
  max-width: 86px;
`;

const TitleText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #f1e8d6;
`;

const EmailText = styled.div`
  font-size: 12px;
  color: #f1e8d6;
`;
